import React, { Component } from 'react'
import { connect } from 'react-redux'
import clsx from 'clsx'
import { faIdBadge } from '@fortawesome/free-solid-svg-icons'

import { userSettings } from '../../actions/userActions'

import { ButtonLink } from '../utils/Button'
import { HeaderLarge as Header } from '../utils/Header'

import Premium from './premium.js'
import UserEmail from './Email'
import UserSms from './Sms'
import WebNotificationsWrapper from './WebNotificationsWrapper'

const ShowSegment = ({ className, children }) => <div className={clsx(className, 'w-full')}>{children}</div>

const connected = connect(store => {
  return {
    isAuthenticated: store.session.isAuthenticated,
    user: store.user.user,
    premium: store.user.premium
  }
})
export class UserSettings extends Component {
  componentWillMount() {
    this.props.dispatch(userSettings())
  }

  render() {
    const { user, isAuthenticated, premium } = this.props

    return (
      <div className="md:flex space-x-0 md:space-x-4">
        <ShowSegment className="md:w-2/3 lg:w-1/2">
          <Header icon={faIdBadge} header={user.email} subHeader={user.email && ' '} />

          <div className="mt-12 w-2/3">
            {isAuthenticated && (
              <ButtonLink to="/sign-out" color="gray">
                Sign Out
              </ButtonLink>
            )}
            {!!!isAuthenticated && (
              <ButtonLink to="/sign-in" color="green">
                Sign In
              </ButtonLink>
            )}
          </div>

          {user.email && premium ? (
            <div>
              <UserSms />
              <UserEmail />
              {user.feature_web_notifications && <WebNotificationsWrapper />}
            </div>
          ) : (
            <p>Premium members can get notified via SMS.</p>
          )}
        </ShowSegment>

        <ShowSegment className="md:w-1/3 lg:w-1/2 mt-12 md:mt-0">
          <Premium />
        </ShowSegment>
      </div>
    )
  }
}

export default connected(UserSettings)
